function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { css } from '@emotion/react';
var element = 'button';
var className = 'menu-item';
var variants = ['success', 'info', 'error', 'warning'];
/**
 * We export the objects as well for compatibilty with 3rd party libs like react-select
 */
/**
 *
 * @alias menuItemStateStylesObjects
 */
var stateStylesObjects = {
  active: {
    color: 'var(--text)',
    background: 'var(--surface-active)'
  },
  focus: {
    color: 'var(--text)',
    background: 'var(--surface-hover)'
  },
  selected: {
    color: 'var(--text)',
    background: 'var(--surface-active)'
  },
  hover: {
    background: 'var(--surface-hover)'
  }
};
var baseStylesObject = {
  font: 'var(--body-1)',
  color: 'var(--text)',
  padding: 'var(--spacing-l3)',
  borderRadius: 'var(--border-radius-small)',
  display: 'grid',
  gridGap: 'var(--spacing-l2)',
  gridAutoFlow: 'column',
  alignItems: 'center',
  flex: '1 1 100%',
  justifyContent: 'flex-start',
  textDecoration: 'none !important',
  outline: 'none',
  '&:is(button, :any-link)': {
    cursor: 'pointer'
  },
  '&[data-variant="success"]': {
    color: 'var(--success)'
  },
  '&[data-variant="info"]': {
    color: 'var(--info)'
  },
  '&[data-variant="error"]': {
    color: 'var(--error)'
  },
  '&[data-variant="warning"]': {
    color: 'var(--warning)'
  }
};
// eslint-disable-next-line @emotion/syntax-preference
var baseStyles = /*#__PURE__*/css(_objectSpread(_objectSpread({}, baseStylesObject), {}, {
  '&:is(button, :any-link):active': stateStylesObjects.active,
  '&:is(button, :any-link)[data-pseudo="active"]': stateStylesObjects.active,
  '&:is(button, :any-link):focus': stateStylesObjects.focus,
  '&:is(button, :any-link)[data-pseudo="focus"]': stateStylesObjects.focus,
  '&:is(button, :any-link):hover': stateStylesObjects.hover,
  '&:is(button, :any-link)[data-pseudo="hover"]': stateStylesObjects.hover,
  '&[data-selected=true]': stateStylesObjects.selected
}), process.env.NODE_ENV === "production" ? "" : ";label:baseStyles;");
export { baseStyles, baseStylesObject, className, element, stateStylesObjects };
